import { Moon, Sun } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useTheme } from "@/contexts/ThemeContext";
import { cn } from "@/lib/utils";

type Props = {
  variant?: "icon" | "labeled";
  className?: string;
};

export function ThemeToggle({ variant = "icon", className }: Props) {
  const { theme, toggleTheme, switchable } = useTheme();

  if (!switchable || !toggleTheme) return null;

  const isDark = theme === "dark";

  return (
    <Button
      type="button"
      variant="ghost"
      size={variant === "labeled" ? "sm" : "icon"}
      onClick={toggleTheme}
      className={cn(
        variant === "labeled" && "gap-2 text-xs",
        className
      )}
      aria-label={isDark ? "تفعيل الوضع الفاتح" : "تفعيل الوضع الداكن"}
    >
      {isDark ? <Sun className="size-4" /> : <Moon className="size-4" />}
      {variant === "labeled" ? (
        <span>{isDark ? "وضع فاتح" : "وضع داكن"}</span>
      ) : null}
    </Button>
  );
}
